module.exports = __webpack_public_path__ + "img/print-placeholder.7b4279c3.svg";